<!-- <div #IOSTEST class="testios" [ngStyle]="{'display':profile.adId === 'sdf1ndj' ? 'block' : 'none' }">TESTING 123...</div>  -->

<title>{{ title }}</title>
<div class="site-wrapper mat-app-background">
  <app-nav-bar></app-nav-bar>
  <router-outlet></router-outlet>
  <app-toasts aria-live="polite" aria-atomic="true"></app-toasts>
</div>

